/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.v2.CopilotMessageService
 */

export const ActionPayloadDiscriminantKey = 'intent';
export const TemplatePayloadDiscriminantKey = 'intent';
export const AskAcademyRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskAcademyRequest';
export const AskAcademyRequestDiscriminant = 'ask_academy';
export const AskAcademyRequestDiscriminantKey = 'intent';
export const AskInAppHelpRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskInAppHelpRequest';
export const AskInAppHelpRequestDiscriminant = 'ask_inapphelp';
export const AskInAppHelpRequestDiscriminantKey = 'intent';
export const CompanyCompetitorsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyCompetitorsRequest';
export const CompanyCompetitorsRequestDiscriminant = 'company_competitors';
export const CompanyCompetitorsRequestDiscriminantKey = 'intent';
export const CompanyFundingRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyFundingRequest';
export const CompanyFundingRequestDiscriminant = 'company_funding';
export const CompanyFundingRequestDiscriminantKey = 'intent';
export const CompanyLookupRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyLookupRequest';
export const CompanyLookupRequestDiscriminant = 'company_lookup';
export const CompanyLookupRequestDiscriminantKey = 'intent';
export const CompanyTechRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyTechRequest';
export const CompanyTechRequestDiscriminant = 'company_tech';
export const CompanyTechRequestDiscriminantKey = 'intent';
export const ContentRewriteRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ContentRewriteRequest';
export const ContentRewriteRequestDiscriminant = 'content_rewrite';
export const ContentRewriteRequestDiscriminantKey = 'intent';
export const CopilotCapabilitiesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CopilotCapabilitiesRequest';
export const CopilotCapabilitiesRequestDiscriminant = 'copilot_capabilities';
export const CopilotCapabilitiesRequestDiscriminantKey = 'intent';
export const CreateBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateBlogPostRequest';
export const CreateBlogPostRequestDiscriminant = 'create_blog_post';
export const CreateBlogPostRequestDiscriminantKey = 'intent';
export const CreateNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateNewsSubscriptionRequest';
export const CreateNewsSubscriptionRequestDiscriminant = 'create_news_subscription';
export const CreateNewsSubscriptionRequestDiscriminantKey = 'intent';
export const CustomSystemPromptRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CustomSystemPromptRequest';
export const CustomSystemPromptRequestDiscriminant = 'custom_system_prompt';
export const CustomSystemPromptRequestDiscriminantKey = 'intent';
export const DeleteNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DeleteNewsSubscriptionRequest';
export const DeleteNewsSubscriptionRequestDiscriminant = 'delete_news_subscription';
export const DeleteNewsSubscriptionRequestDiscriminantKey = 'intent';
export const DiscoverCompaniesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DiscoverCompaniesRequest';
export const DiscoverCompaniesRequestDiscriminant = 'discover_companies';
export const DiscoverCompaniesRequestDiscriminantKey = 'intent';
export const DraftBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftBlogPostRequest';
export const DraftBlogPostRequestDiscriminant = 'draft_blog_post';
export const DraftBlogPostRequestDiscriminantKey = 'intent';
export const DraftSalesEmailRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailRequest';
export const DraftSalesEmailRequestDiscriminant = 'draft_sales_email';
export const DraftSalesEmailRequestDiscriminantKey = 'intent';
export const DraftSalesEmailTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailTemplateRequest';
export const DraftSalesEmailTemplateRequestDiscriminant = 'draft_sales_email';
export const DraftSalesEmailTemplateRequestDiscriminantKey = 'intent';
export const ImageGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ImageGenerateRequest';
export const ImageGenerateRequestDiscriminant = 'image_generate';
export const ImageGenerateRequestDiscriminantKey = 'intent';
export const ListNewsSubscriptionsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNewsSubscriptionsRequest';
export const ListNewsSubscriptionsRequestDiscriminant = 'list_news_subscription';
export const ListNewsSubscriptionsRequestDiscriminantKey = 'intent';
export const ListNotesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNotesRequest';
export const ListNotesRequestDiscriminant = 'list_notes';
export const ListNotesRequestDiscriminantKey = 'intent';
export const NewsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NewsRequest';
export const NewsRequestDiscriminant = 'news';
export const NewsRequestDiscriminantKey = 'intent';
export const NoteCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateRequest';
export const NoteCreateRequestDiscriminant = 'note_create';
export const NoteCreateRequestDiscriminantKey = 'intent';
export const NoteCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateTemplateRequest';
export const NoteCreateTemplateRequestDiscriminant = 'note_create';
export const NoteCreateTemplateRequestDiscriminantKey = 'intent';
export const ObjectAddRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAddRequest';
export const ObjectAddRequestDiscriminant = 'object_add';
export const ObjectAddRequestDiscriminantKey = 'intent';
export const ObjectAssignRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssignRequest';
export const ObjectAssignRequestDiscriminant = 'object_assign';
export const ObjectAssignRequestDiscriminantKey = 'intent';
export const ObjectAssociationsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssociationsRequest';
export const ObjectAssociationsRequestDiscriminant = 'object_associations';
export const ObjectAssociationsRequestDiscriminantKey = 'intent';
export const ObjectCountRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectCountRequest';
export const ObjectCountRequestDiscriminant = 'object_count';
export const ObjectCountRequestDiscriminantKey = 'intent';
export const ObjectListRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectListRequest';
export const ObjectListRequestDiscriminant = 'object_list';
export const ObjectListRequestDiscriminantKey = 'intent';
export const ObjectSummaryRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectSummaryRequest';
export const ObjectSummaryRequestDiscriminant = 'object_summary';
export const ObjectSummaryRequestDiscriminantKey = 'intent';
export const ObjectUpdateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectUpdateRequest';
export const ObjectUpdateRequestDiscriminant = 'object_update';
export const ObjectUpdateRequestDiscriminantKey = 'intent';
export const OrchestrationPlanExecutionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanExecutionRequest';
export const OrchestrationPlanExecutionRequestDiscriminant = 'orchestration_plan_execution';
export const OrchestrationPlanExecutionRequestDiscriminantKey = 'intent';
export const OrchestrationPlanningRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanningRequest';
export const OrchestrationPlanningRequestDiscriminant = 'reasoning';
export const OrchestrationPlanningRequestDiscriminantKey = 'intent';
export const ReportBuilderRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ReportBuilderRequest';
export const ReportBuilderRequestDiscriminant = 'report_builder';
export const ReportBuilderRequestDiscriminantKey = 'intent';
export const SummarizeArticleRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.SummarizeArticleRequest';
export const SummarizeArticleRequestDiscriminant = 'summarize_article';
export const SummarizeArticleRequestDiscriminantKey = 'intent';
export const TaskCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateRequest';
export const TaskCreateRequestDiscriminant = 'task_create';
export const TaskCreateRequestDiscriminantKey = 'intent';
export const TaskCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateTemplateRequest';
export const TaskCreateTemplateRequestDiscriminant = 'task_create';
export const TaskCreateTemplateRequestDiscriminantKey = 'intent';
export const TextGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TextGenerateRequest';
export const TextGenerateRequestDiscriminant = 'text_generate';
export const TextGenerateRequestDiscriminantKey = 'intent';
export const ActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButton';
export const ActionButtonDiscriminant = 'ACTION';
export const ActionButtonDiscriminantKey = 'type';
export const ActionButtonV2Typename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButtonV2';
export const ActionButtonV2Discriminant = 'ACTION_V2';
export const ActionButtonV2DiscriminantKey = 'type';
export const BreezeActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.BreezeActionButton';
export const BreezeActionButtonDiscriminant = 'BREEZE_ACTION';
export const BreezeActionButtonDiscriminantKey = 'type';
export const ButtonDiscriminantKey = 'type';
export const InvokeSkillButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.InvokeSkillButton';
export const InvokeSkillButtonDiscriminant = 'INVOKE_SKILL';
export const InvokeSkillButtonDiscriminantKey = 'type';
export const LinkButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.LinkButton';
export const LinkButtonDiscriminant = 'LINK';
export const LinkButtonDiscriminantKey = 'type';
export const TemplateButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.TemplateButton';
export const TemplateButtonDiscriminant = 'TEMPLATE';
export const TemplateButtonDiscriminantKey = 'type';
export const AccordionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AccordionResponseSection';
export const AccordionResponseSectionDiscriminant = 'ACCORDION';
export const AccordionResponseSectionDiscriminantKey = 'type';
export const ActionsResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ActionsResponseSection';
export const ActionsResponseSectionDiscriminant = 'ACTION';
export const ActionsResponseSectionDiscriminantKey = 'type';
export const ArtifactCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ArtifactCardResponseSection';
export const ArtifactCardResponseSectionDiscriminant = 'ARTIFACT_CARD';
export const ArtifactCardResponseSectionDiscriminantKey = 'type';
export const AskQuestionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AskQuestionResponseSection';
export const AskQuestionResponseSectionDiscriminant = 'ASK_QUESTION';
export const AskQuestionResponseSectionDiscriminantKey = 'type';
export const AvatarCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AvatarCardResponseSection';
export const AvatarCardResponseSectionDiscriminant = 'AVATAR_CARD';
export const AvatarCardResponseSectionDiscriminantKey = 'type';
export const BarChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.BarChartResponseSection';
export const BarChartResponseSectionDiscriminant = 'BAR_CHART';
export const BarChartResponseSectionDiscriminantKey = 'type';
export const CalendarConnectResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CalendarConnectResponseSection';
export const CalendarConnectResponseSectionDiscriminant = 'CALENDAR_CONNECT';
export const CalendarConnectResponseSectionDiscriminantKey = 'type';
export const CardWrapperResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CardWrapperResponseSection';
export const CardWrapperResponseSectionDiscriminant = 'CARD_WRAPPER';
export const CardWrapperResponseSectionDiscriminantKey = 'type';
export const ChipsCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ChipsCardResponseSection';
export const ChipsCardResponseSectionDiscriminant = 'CHIPS_CARD';
export const ChipsCardResponseSectionDiscriminantKey = 'type';
export const CollaborationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CollaborationResponseSection';
export const CollaborationResponseSectionDiscriminant = 'COLLABORATE';
export const CollaborationResponseSectionDiscriminantKey = 'type';
export const CompanyOverviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CompanyOverviewResponseSection';
export const CompanyOverviewResponseSectionDiscriminant = 'COMPANY_OVERVIEW';
export const CompanyOverviewResponseSectionDiscriminantKey = 'type';
export const ConfirmationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ConfirmationResponseSection';
export const ConfirmationResponseSectionDiscriminant = 'CONFIRMATION';
export const ConfirmationResponseSectionDiscriminantKey = 'type';
export const CrmCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CrmCardResponseSection';
export const CrmCardResponseSectionDiscriminant = 'CRM_CARD';
export const CrmCardResponseSectionDiscriminantKey = 'type';
export const CustomComponentResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CustomComponentResponseSection';
export const CustomComponentResponseSectionDiscriminant = 'CUSTOM_COMPONENT';
export const CustomComponentResponseSectionDiscriminantKey = 'type';
export const DashboardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DashboardResponseSection';
export const DashboardResponseSectionDiscriminant = 'DASHBOARD';
export const DashboardResponseSectionDiscriminantKey = 'type';
export const DataChangeResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DataChangeResponseSection';
export const DataChangeResponseSectionDiscriminant = 'DATA_CHANGE';
export const DataChangeResponseSectionDiscriminantKey = 'type';
export const DataTableResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSection';
export const DataTableResponseSectionDiscriminant = 'DATA_TABLE';
export const DataTableResponseSectionDiscriminantKey = 'type';
export const DataTableResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSectionV2';
export const DataTableResponseSectionV2Discriminant = 'DATA_TABLE_V2';
export const DataTableResponseSectionV2DiscriminantKey = 'type';
export const DenseListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DenseListResponseSection';
export const DenseListResponseSectionDiscriminant = 'DENSE_LIST';
export const DenseListResponseSectionDiscriminantKey = 'type';
export const DraftEmailResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DraftEmailResponseSection';
export const DraftEmailResponseSectionDiscriminant = 'DRAFT_EMAIL';
export const DraftEmailResponseSectionDiscriminantKey = 'type';
export const EmailDraftCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.EmailDraftCardResponseSection';
export const EmailDraftCardResponseSectionDiscriminant = 'EMAIL_DRAFT_CARD';
export const EmailDraftCardResponseSectionDiscriminantKey = 'type';
export const ErrorResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ErrorResponseSection';
export const ErrorResponseSectionDiscriminant = 'ERROR';
export const ErrorResponseSectionDiscriminantKey = 'type';
export const FilterBranchResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.FilterBranchResponseSection';
export const FilterBranchResponseSectionDiscriminant = 'FILTER_BRANCH';
export const FilterBranchResponseSectionDiscriminantKey = 'type';
export const GetToKnowMeCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.GetToKnowMeCardResponseSection';
export const GetToKnowMeCardResponseSectionDiscriminant = 'GET_TO_KNOW_ME_CARD';
export const GetToKnowMeCardResponseSectionDiscriminantKey = 'type';
export const GridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.GridResponseSection';
export const GridResponseSectionDiscriminant = 'GRID';
export const GridResponseSectionDiscriminantKey = 'type';
export const HighchartsChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HighchartsChartResponseSection';
export const HighchartsChartResponseSectionDiscriminant = 'HIGHCHARTS_CHART';
export const HighchartsChartResponseSectionDiscriminantKey = 'type';
export const HtmlCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlCardResponseSection';
export const HtmlCardResponseSectionDiscriminant = 'HTML_CARD';
export const HtmlCardResponseSectionDiscriminantKey = 'type';
export const HtmlTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlTextResponseSection';
export const HtmlTextResponseSectionDiscriminant = 'HTML';
export const HtmlTextResponseSectionDiscriminantKey = 'type';
export const HtmlWithChildrenResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlWithChildrenResponseSection';
export const HtmlWithChildrenResponseSectionDiscriminant = 'HTML_WITH_CHILDREN';
export const HtmlWithChildrenResponseSectionDiscriminantKey = 'type';
export const InlineAcademyVideoResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.InlineAcademyVideoResponseSection';
export const InlineAcademyVideoResponseSectionDiscriminant = 'INLINE_ACADEMY_VIDEO';
export const InlineAcademyVideoResponseSectionDiscriminantKey = 'type';
export const InlineCitationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.InlineCitationResponseSection';
export const InlineCitationResponseSectionDiscriminant = 'INLINE_CITATION';
export const InlineCitationResponseSectionDiscriminantKey = 'type';
export const LlmResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection';
export const LlmResponseSectionDiscriminant = 'LLM';
export const LlmResponseSectionDiscriminantKey = 'type';
export const MarketplaceCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.MarketplaceCardResponseSection';
export const MarketplaceCardResponseSectionDiscriminant = 'MARKETPLACE_CARD';
export const MarketplaceCardResponseSectionDiscriminantKey = 'type';
export const MetricCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.MetricCardResponseSection';
export const MetricCardResponseSectionDiscriminant = 'METRIC_CARD';
export const MetricCardResponseSectionDiscriminantKey = 'type';
export const NewsListCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.NewsListCardResponseSection';
export const NewsListCardResponseSectionDiscriminant = 'NEWS_LIST_CARD';
export const NewsListCardResponseSectionDiscriminantKey = 'type';
export const PlainTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.PlainTextResponseSection';
export const PlainTextResponseSectionDiscriminant = 'PLAIN_TEXT';
export const PlainTextResponseSectionDiscriminantKey = 'type';
export const ReportResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ReportResponseSection';
export const ReportResponseSectionDiscriminant = 'REPORT';
export const ReportResponseSectionDiscriminantKey = 'type';
export const ResponseSectionDiscriminantKey = 'type';
export const ScheduledPromptResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ScheduledPromptResponseSection';
export const ScheduledPromptResponseSectionDiscriminant = 'SCHEDULED_PROMPT';
export const ScheduledPromptResponseSectionDiscriminantKey = 'type';
export const SourcesListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.SourcesListResponseSection';
export const SourcesListResponseSectionDiscriminant = 'SOURCES_LIST';
export const SourcesListResponseSectionDiscriminantKey = 'type';
export const SupportHandoffResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.SupportHandoffResponseSection';
export const SupportHandoffResponseSectionDiscriminant = 'SUPPORT_HANDOFF';
export const SupportHandoffResponseSectionDiscriminantKey = 'type';
export const TabResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TabResponseSection';
export const TabResponseSectionDiscriminant = 'TAB';
export const TabResponseSectionDiscriminantKey = 'type';
export const TemplateResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TemplateResponseSection';
export const TemplateResponseSectionDiscriminant = 'TEMPLATE';
export const TemplateResponseSectionDiscriminantKey = 'type';
export const ThoughtResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ThoughtResponseSection';
export const ThoughtResponseSectionDiscriminant = 'THOUGHT';
export const ThoughtResponseSectionDiscriminantKey = 'type';
export const TimelineCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TimelineCardResponseSection';
export const TimelineCardResponseSectionDiscriminant = 'TIMELINE_CARD';
export const TimelineCardResponseSectionDiscriminantKey = 'type';
export const UnstyledImageResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UnstyledImageResponseSection';
export const UnstyledImageResponseSectionDiscriminant = 'UNSTYLED_IMAGE';
export const UnstyledImageResponseSectionDiscriminantKey = 'type';
export const UserActionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserActionResponseSection';
export const UserActionResponseSectionDiscriminant = 'USER_ACTION';
export const UserActionResponseSectionDiscriminantKey = 'type';
export const UserAlertResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserAlertResponseSection';
export const UserAlertResponseSectionDiscriminant = 'USER_ALERT';
export const UserAlertResponseSectionDiscriminantKey = 'type';
export const UserChatResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserChatResponseSection';
export const UserChatResponseSectionDiscriminant = 'USER_CHAT';
export const UserChatResponseSectionDiscriminantKey = 'type';
export const VisualizationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.VisualizationResponseSection';
export const VisualizationResponseSectionDiscriminant = 'VISUALIZATION';
export const VisualizationResponseSectionDiscriminantKey = 'type';
export const CatalogItemRecommendationSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.academy.CatalogItemRecommendationSection';
export const CatalogItemRecommendationSectionDiscriminant = 'ACADEMY_CATALOG_RECOMMENDATION_CARD';
export const CatalogItemRecommendationSectionDiscriminantKey = 'type';
export const ArtifactPayloadDiscriminantKey = 'kind';
export const EmailArtifactPayloadTypename = 'com.hubspot.chatspot.message.schemas.sections.artifacts.EmailArtifactPayload';
export const EmailArtifactPayloadDiscriminant = 'EMAIL';
export const EmailArtifactPayloadDiscriminantKey = 'kind';
export const HtmlArtifactPayloadTypename = 'com.hubspot.chatspot.message.schemas.sections.artifacts.HtmlArtifactPayload';
export const HtmlArtifactPayloadDiscriminant = 'HTML';
export const HtmlArtifactPayloadDiscriminantKey = 'kind';
export const MarkdownArtifactPayloadTypename = 'com.hubspot.chatspot.message.schemas.sections.artifacts.MarkdownArtifactPayload';
export const MarkdownArtifactPayloadDiscriminant = 'MARKDOWN';
export const MarkdownArtifactPayloadDiscriminantKey = 'kind';
export const ReportArtifactPayloadTypename = 'com.hubspot.chatspot.message.schemas.sections.artifacts.ReportArtifactPayload';
export const ReportArtifactPayloadDiscriminant = 'REPORT';
export const ReportArtifactPayloadDiscriminantKey = 'kind';
export const CardDiscriminantKey = 'type';
export const CardFieldValueDiscriminantKey = 'valueType';
export const CardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CardResponseSection';
export const CardResponseSectionDiscriminant = 'CARD';
export const CardResponseSectionDiscriminantKey = 'type';
export const CompanyCardTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CompanyCard';
export const CompanyCardDiscriminant = 'COMPANY';
export const CompanyCardDiscriminantKey = 'type';
export const DoubleCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.DoubleCardFieldValue';
export const DoubleCardFieldValueDiscriminant = 'DOUBLE';
export const DoubleCardFieldValueDiscriminantKey = 'valueType';
export const IntegerCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.IntegerCardFieldValue';
export const IntegerCardFieldValueDiscriminant = 'INTEGER';
export const IntegerCardFieldValueDiscriminantKey = 'valueType';
export const LinkCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.LinkCardFieldValue';
export const LinkCardFieldValueDiscriminant = 'LINK';
export const LinkCardFieldValueDiscriminantKey = 'valueType';
export const StringCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.StringCardFieldValue';
export const StringCardFieldValueDiscriminant = 'STRING';
export const StringCardFieldValueDiscriminantKey = 'valueType';
export let ComHubspotChatspotMessageSchemasSectionsCitation;
(function (_ComHubspotChatspotMessageSchemasSectionsCitation) {})(ComHubspotChatspotMessageSchemasSectionsCitation || (ComHubspotChatspotMessageSchemasSectionsCitation = {}));
export const ActivityBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.ActivityBlock';
export const ActivityBlockDiscriminant = 'ACTIVITY';
export const ActivityBlockDiscriminantKey = 'blockType';
export const BadgeBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.BadgeBlock';
export const BadgeBlockDiscriminant = 'BADGE';
export const BadgeBlockDiscriminantKey = 'blockType';
export const ComposableBlockDiscriminantKey = 'blockType';
export const ComposableCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.ComposableCardResponseSection';
export const ComposableCardResponseSectionDiscriminant = 'COMPOSABLE_CARD';
export const ComposableCardResponseSectionDiscriminantKey = 'type';
export const CrmObjectBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.CrmObjectBlock';
export const CrmObjectBlockDiscriminant = 'CRM_OBJECT';
export const CrmObjectBlockDiscriminantKey = 'blockType';
export const DateBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.DateBlock';
export const DateBlockDiscriminant = 'DATE';
export const DateBlockDiscriminantKey = 'blockType';
export const DividerBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.DividerBlock';
export const DividerBlockDiscriminant = 'DIVIDER';
export const DividerBlockDiscriminantKey = 'blockType';
export const TextFieldBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.TextFieldBlock';
export const TextFieldBlockDiscriminant = 'TEXT_FIELD';
export const TextFieldBlockDiscriminantKey = 'blockType';
export const TimelineBlockTypename = 'com.hubspot.chatspot.message.schemas.sections.composable.TimelineBlock';
export const TimelineBlockDiscriminant = 'TIMELINE';
export const TimelineBlockDiscriminantKey = 'blockType';
export const ContextItemResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.contextitem.ContextItemResponseSection';
export const ContextItemResponseSectionDiscriminant = 'CONTEXT_ITEM';
export const ContextItemResponseSectionDiscriminantKey = 'type';
export const FileAttachmentResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.file.FileAttachmentResponseSection';
export const FileAttachmentResponseSectionDiscriminant = 'FILE_ATTACHMENT';
export const FileAttachmentResponseSectionDiscriminantKey = 'type';
export const ImageGridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.image.ImageGridResponseSection';
export const ImageGridResponseSectionDiscriminant = 'IMAGE_GRID';
export const ImageGridResponseSectionDiscriminantKey = 'type';
export const DescriptionSectionDiscriminantKey = 'type';
export const MediaPreviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSection';
export const MediaPreviewResponseSectionDiscriminant = 'MEDIA';
export const MediaPreviewResponseSectionDiscriminantKey = 'type';
export const MediaPreviewResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSectionV2';
export const MediaPreviewResponseSectionV2Discriminant = 'MEDIA_V2';
export const MediaPreviewResponseSectionV2DiscriminantKey = 'type';
export const MeetingCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingCardResponseSection';
export const MeetingCardResponseSectionDiscriminant = 'MEETING_CARD';
export const MeetingCardResponseSectionDiscriminantKey = 'type';
export const MeetingPrepActionDataResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingPrepActionDataResponseSection';
export const MeetingPrepActionDataResponseSectionDiscriminant = 'MEETING_PREP_ACTION_DATA';
export const MeetingPrepActionDataResponseSectionDiscriminantKey = 'type';
export const MeetingRecapActionDataResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingRecapActionDataResponseSection';
export const MeetingRecapActionDataResponseSectionDiscriminant = 'MEETING_RECAP_ACTION_DATA';
export const MeetingRecapActionDataResponseSectionDiscriminantKey = 'type';
export const MeetingResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingResponseSection';
export const MeetingResponseSectionDiscriminant = 'MEETING';
export const MeetingResponseSectionDiscriminantKey = 'type';
export const BrandVoiceFieldTypename = 'com.hubspot.chatspot.message.schemas.sections.metadata.BrandVoiceField';
export const BrandVoiceFieldDiscriminant = 'BRAND_VOICE';
export const BrandVoiceFieldDiscriminantKey = 'type';
export const MetadataFieldDiscriminantKey = 'type';
export const AISkillSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AISkillSourceData';
export const AISkillSourceDataDiscriminant = 'AI_SKILL';
export const AISkillSourceDataDiscriminantKey = 'source';
export const AppSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData';
export const AppSourceDataDiscriminant = 'APP';
export const AppSourceDataDiscriminantKey = 'source';
export const BrandIdentitySourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.BrandIdentitySourceData';
export const BrandIdentitySourceDataDiscriminant = 'BRAND_IDENTITY';
export const BrandIdentitySourceDataDiscriminantKey = 'source';
export const ChatMessageSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.ChatMessageSourceData';
export const ChatMessageSourceDataDiscriminant = 'CHAT_MESSAGE';
export const ChatMessageSourceDataDiscriminantKey = 'source';
export const ContactIdentitySourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.ContactIdentitySourceData';
export const ContactIdentitySourceDataDiscriminant = 'CONTACT_IDENTITY';
export const ContactIdentitySourceDataDiscriminantKey = 'source';
export const CrmObjectSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.CrmObjectSourceData';
export const CrmObjectSourceDataDiscriminant = 'CRM_OBJECT';
export const CrmObjectSourceDataDiscriminantKey = 'source';

/**
 * Virtual record for map with known enum keys
 */

export const FileUploadSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.FileUploadSourceData';
export const FileUploadSourceDataDiscriminant = 'FILE_UPLOAD';
export const FileUploadSourceDataDiscriminantKey = 'source';
export const MemorySourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.MemorySourceData';
export const MemorySourceDataDiscriminant = 'MEMORY';
export const MemorySourceDataDiscriminantKey = 'source';
export const SourceDataDiscriminantKey = 'source';
export const WebsiteSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceData';
export const WebsiteSourceDataDiscriminant = 'WEBSITE';
export const WebsiteSourceDataDiscriminantKey = 'source';
export const AgentProgressStepDiscriminantKey = 'stepType';
export const StepListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.steps.StepListResponseSection';
export const StepListResponseSectionDiscriminant = 'STEP_LIST';
export const StepListResponseSectionDiscriminantKey = 'type';
export const SubagentStepTypename = 'com.hubspot.chatspot.message.schemas.sections.steps.SubagentStep';
export const SubagentStepDiscriminant = 'SUBAGENT';
export const SubagentStepDiscriminantKey = 'stepType';
export const ToolCallStepTypename = 'com.hubspot.chatspot.message.schemas.sections.steps.ToolCallStep';
export const ToolCallStepDiscriminant = 'TOOL_CALL';
export const ToolCallStepDiscriminantKey = 'stepType';
export const VisualizationDiscriminantKey = 'type';
export const CrossTabVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabVisualization';
export const CrossTabVisualizationDiscriminant = 'CROSS_TAB';
export const CrossTabVisualizationDiscriminantKey = 'type';
export const DatawellVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellVisualization';
export const DatawellVisualizationDiscriminant = 'DATAWELL';
export const DatawellVisualizationDiscriminantKey = 'type';
export const FunnelVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.funnel.FunnelVisualization';
export const FunnelVisualizationDiscriminant = 'FUNNEL';
export const FunnelVisualizationDiscriminantKey = 'type';
export const GaugeVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeVisualization';
export const GaugeVisualizationDiscriminant = 'GAUGE';
export const GaugeVisualizationDiscriminantKey = 'type';
export const PivotVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualization';
export const PivotVisualizationDiscriminant = 'PIVOT';
export const PivotVisualizationDiscriminantKey = 'type';
export const SankeyVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyVisualization';
export const SankeyVisualizationDiscriminant = 'SANKEY';
export const SankeyVisualizationDiscriminantKey = 'type';
export const SlicedVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedVisualization';
export const SlicedVisualizationDiscriminant = 'SLICED';
export const SlicedVisualizationDiscriminantKey = 'type';
export const TableVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.table.TableVisualization';
export const TableVisualizationDiscriminant = 'TABLE';
export const TableVisualizationDiscriminantKey = 'type';
export const WaterfallVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallVisualization';
export const WaterfallVisualizationDiscriminant = 'WATERFALL';
export const WaterfallVisualizationDiscriminantKey = 'type';
export const XYVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYVisualization';
export const XYVisualizationDiscriminant = 'XY';
export const XYVisualizationDiscriminantKey = 'type';
export const ActionCellTypename = 'com.hubspot.chatspot.message.schemas.table.ActionCell';
export const ActionCellDiscriminant = 'ACTION';
export const ActionCellDiscriminantKey = 'cellType';
export const ImageCellTypename = 'com.hubspot.chatspot.message.schemas.table.ImageCell';
export const ImageCellDiscriminant = 'IMAGE';
export const ImageCellDiscriminantKey = 'cellType';
export const LinkCellTypename = 'com.hubspot.chatspot.message.schemas.table.LinkCell';
export const LinkCellDiscriminant = 'LINK';
export const LinkCellDiscriminantKey = 'cellType';
export const PlainTextCellTypename = 'com.hubspot.chatspot.message.schemas.table.PlainTextCell';
export const PlainTextCellDiscriminant = 'PLAIN_TEXT';
export const PlainTextCellDiscriminantKey = 'cellType';
export const TableCellDiscriminantKey = 'cellType';
export const LinkTokenTypename = 'com.hubspot.chatspot.message.schemas.tokens.LinkToken';
export const LinkTokenDiscriminant = 'LINK';
export const LinkTokenDiscriminantKey = 'type';
export const ResponseTextTokenDiscriminantKey = 'type';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';

/**
 *  Represents a highlighted UI element or content section that the user has selected
 *  to provide visual context for their message.
 *  <p>Context items allow users to reference specific parts of the UI (buttons, dropdowns,
 *  form fields, etc.) when asking questions. The LLM receives the context item details
 *  to understand exactly what the user is referring to.
 *  <p>Context items are message-specific and do not persist across messages unless
 *  explicitly resent by the frontend.
 */

/**
 *  Represents feedback provided for a copilot message.
 */

export const AgentPayloadDiscriminantKey = '@type';
export const EmptyPayloadTypename = 'com.hubspot.copilot.models.chat.payload.EmptyPayload';
export const EmptyPayloadDiscriminant = 'EMPTY';
export const EmptyPayloadDiscriminantKey = '@type';
export const JsonPayloadTypename = 'com.hubspot.copilot.models.chat.payload.JsonPayload';
export const JsonPayloadDiscriminant = 'JSON';
export const JsonPayloadDiscriminantKey = '@type';
/**
 *  JSON payload for the raw output response.
 */

export const ToolCallPayloadTypename = 'com.hubspot.copilot.models.chat.payload.ToolCallPayload';
export const ToolCallPayloadDiscriminant = 'TOOL_CALL';
export const ToolCallPayloadDiscriminantKey = '@type';

/**
 *  Defines input for interactive tools with pre-built JSON schema and action context.
 */

/**
 *  Request to get a message by its ID.
 */

/**
 *  Response for getting a message by its ID.
 */

export const BrandIdentityCitationTypename = 'com.hubspot.copilot.tools.results.citations.BrandIdentityCitation';
export const BrandIdentityCitationDiscriminant = 'BRAND_IDENTITY';
export const BrandIdentityCitationDiscriminantKey = 'citationType';
export const ChatMessageCitationTypename = 'com.hubspot.copilot.tools.results.citations.ChatMessageCitation';
export const ChatMessageCitationDiscriminant = 'CHAT_MESSAGE';
export const ChatMessageCitationDiscriminantKey = 'citationType';
export const CrmCitationTypename = 'com.hubspot.copilot.tools.results.citations.CrmCitation';
export const CrmCitationDiscriminant = 'CRM';
export const CrmCitationDiscriminantKey = 'citationType';
export const DashworksCitationTypename = 'com.hubspot.copilot.tools.results.citations.DashworksCitation';
export const DashworksCitationDiscriminant = 'DASHWORKS';
export const DashworksCitationDiscriminantKey = 'citationType';
export const FileUploadCitationTypename = 'com.hubspot.copilot.tools.results.citations.FileUploadCitation';
export const FileUploadCitationDiscriminant = 'FILE_UPLOAD';
export const FileUploadCitationDiscriminantKey = 'citationType';
export const InternalCitationTypename = 'com.hubspot.copilot.tools.results.citations.InternalCitation';
export const InternalCitationDiscriminant = 'INTERNAL';
export const InternalCitationDiscriminantKey = 'citationType';
export const LegacyCitationTypename = 'com.hubspot.copilot.tools.results.citations.LegacyCitation';
export const LegacyCitationDiscriminant = 'LEGACY';
export const LegacyCitationDiscriminantKey = 'citationType';
export const MemoryCitationTypename = 'com.hubspot.copilot.tools.results.citations.MemoryCitation';
export const MemoryCitationDiscriminant = 'MEMORY';
export const MemoryCitationDiscriminantKey = 'citationType';
export const WebPageCitationTypename = 'com.hubspot.copilot.tools.results.citations.WebPageCitation';
export const WebPageCitationDiscriminant = 'WEBPAGE';
export const WebPageCitationDiscriminantKey = 'citationType';
export let ComHubspotCopilotToolsResultsCitations;
(function (_ComHubspotCopilotToolsResultsCitations) {
  const CitationDiscriminantKey = _ComHubspotCopilotToolsResultsCitations.CitationDiscriminantKey = 'citationType';
})(ComHubspotCopilotToolsResultsCitations || (ComHubspotCopilotToolsResultsCitations = {}));
export const getMessageByIdRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotMessageService',
  rpcName: 'getMessageById',
  auth: 'app',
  fingerprint: 'NvrAWWitnsX2qXr6loinuJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateEmailDraftSectionRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotMessageService',
  rpcName: 'updateEmailDraftSection',
  auth: 'app',
  fingerprint: 'RI83lsp3zeEuSeiqTApgwTdov5f-VKFU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};